import request from "superagent";
import networkLogger from "../networkLogger";
import { graphQLRequestIAM } from '../graphQLService';

const AssignmentUrl = process.env.ASSIGNMENT_SERVICE_URL;

/**
 * http helper for sending GraphQL requests to the assignment service
 * @param {string} query - assignment GraphQL query
 * @param {object} variables - assignment GraphQL query variables
 * @returns {Promise<*>}
 */
async function graphqlRequest(query, variables) {
  const startTime = Date.now();
  try {
    const response = await graphQLRequestIAM(AssignmentUrl, query, variables, 3);
    const duration = Date.now() - startTime;

    if (response.errors) {
      console.log(response.errors);
      networkLogger.logGraphQLError(
        'AssignmentService',
        AssignmentUrl,
        null,
        response.errors,
        duration
      );
      const graphqlError = new Error(response.errors[0].message);
      graphqlError.isGraphQLError = true; // Mark to prevent double-logging
      throw graphqlError;
    }

    return response.data;
  } catch (error) {
    // Only log network/request errors (GraphQL errors already logged above)
    if (!error.isGraphQLError) {
      networkLogger.logGraphQLError(
        'AssignmentService',
        AssignmentUrl,
        null,
        error,
        Date.now() - startTime
      );
    }
    throw error;
  }
}

export default graphqlRequest;